var userAgent = require('../internals/engine-user-agent');
var global = require('../internals/global');

module.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/engine-is-ios-pebble.js
// module id = 305
// module chunks = 0 1